module.exports = __webpack_public_path__ + "static/img/12.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/sp/12.png
// module id = CiQg
// module chunks = 0